import { render, staticRenderFns } from "./ageData.vue?vue&type=template&id=2bb6d0be&scoped=true"
import script from "./ageData.vue?vue&type=script&lang=js"
export * from "./ageData.vue?vue&type=script&lang=js"
import style0 from "./ageData.vue?vue&type=style&index=0&id=2bb6d0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb6d0be",
  null
  
)

export default component.exports